"use client";

import { useState } from "react";
import Icon from "./Icon/Icon";
import { useForm } from "react-hook-form";

export default function NewsletterForm() {
  // When the user enters their e-mail and submits the form, the action is
  // called, which will add their mail address to the newsletter The e-mail
  // address is checked on the FE, but should also be checked in this action to
  // be valid. By using fetcher.form we can call the action route without
  // navigating to that route (since that route isn't actually a real-route but
  // this action will be callable from every page)

  const {
    formState: { isSubmitting },
    register,
    reset,
    handleSubmit,
  } = useForm<{
    email: string;
  }>();

  const [message, setMessage] = useState<string | null>(null);

  const onSubmit = handleSubmit(async (data) => {
    const response = await fetch("api/subscribe", {
      method: "POST",
      body: JSON.stringify(data),
    });
    const res = (await response.json()) as { message: string };
    setMessage(res.message);
    reset();
  });

  return (
    <form
      method="POST"
      className="relative mt-auto flex w-full max-w-xs flex-col md:max-w-none"
      onSubmit={onSubmit}
    >
      <div className="flex w-full flex-col">
        <div className="relative flex overflow-hidden">
          <input
            {...register("email", { required: true })}
            type="email"
            required
            id="newsletter-email"
            placeholder="Your email address"
            className="footer-input peer w-full max-w-88 grow border border-r-0 border-white bg-white px-3 py-2 text-body text-black outline-0 transition-colors placeholder:placeholder:font-nb-bold placeholder-shown:bg-black autofill:bg-white focus:bg-white"
            onFocus={() => setMessage(null)}
          ></input>
          <label
            htmlFor="newsletter-email"
            className="absolute -top-0.5 left-0.5 -translate-y-16 bg-black pl-3 text-body text-white transition-transform peer-placeholder-shown:translate-y-1/2 peer-focus:-translate-y-12 peer-placeholder-shown:peer-focus:-translate-y-12 md:-top-1"
          >
            Subscribe to our newsletter
          </label>
          <button
            type="submit"
            name="_action"
            value="newsletter"
            className="group cursor-pointer whitespace-nowrap border border-l-0 border-white bg-white px-4 text-white outline-0 transition-colors peer-placeholder-shown:bg-black peer-valid:hover:border-blue peer-valid:hover:bg-blue peer-valid:active:border-blue peer-valid:active:bg-blue peer-focus:border-white peer-focus:bg-white peer-placeholder-shown:peer-focus:border-white peer-placeholder-shown:peer-focus:bg-white"
            aria-label="Sign up to NewCold's newsletter"
            disabled={isSubmitting}
          >
            <Icon type="arrow" className="w-8 stroke-white transition-colors" />
          </button>
        </div>
      </div>
      <div className="relative pb-8 md:pb-0">
        {message && (
          <span className="absolute left-0 top-0 mt-2 text-body text-white">
            {message}
          </span>
        )}
      </div>
    </form>
  );
}
